const COPY = ['fill', 'stroke', 'stroke-width', 'stroke-dasharray', 'stroke-linejoin', 'stroke-linecap', 'opacity', 'font-size', 'font-weight', 'font-style', 'text-anchor', 'dominant-baseline'] as const

const isTransparent = (v: string) => /^rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*0\s*\)$/.test(v) || v === 'transparent'
const px = (v: string) => v.replace(/px/g, '').replace(/,\s*/g, ' ').trim()
// svg2pdf.js 2.8.1 checks fontWeight === 'bold' by strict string equality (dist/svg2pdf.umd.min.js) —
// a numeric computed weight like "600"/"700" never matches, so Tailwind's font-semibold/font-medium
// would silently render as regular weight. Normalise here instead.
const isBoldWeight = (v: string) => v === 'bold' || (!isNaN(parseInt(v, 10)) && parseInt(v, 10) >= 600)

/**
 * Turns "screen SVG" (Tailwind utility classes) into "portable SVG" (presentation attributes) for
 * svg2pdf.js — and later svg-to-pdfkit — which cannot resolve a stylesheet (spec §6). Two passes:
 * read every element's computed style first, then write attributes and drop the classes, so removing
 * a parent's class never changes a child's computed value mid-walk.
 */
export const inlineComputedStyles = (svg: SVGSVGElement, fontFamily: string): void => {
  const els: Element[] = [svg as Element].concat(Array.from(svg.querySelectorAll('*')))
  const snap = els.map((el) => { const cs = getComputedStyle(el); return COPY.map((p) => cs.getPropertyValue(p)) })
  els.forEach((el, i) => {
    if (el.tagName === 'clipPath' || el.closest('clipPath')) { el.removeAttribute('class'); return }
    COPY.forEach((p, j) => {
      let v = snap[i][j]
      if (!v) return
      if ((p === 'fill' || p === 'stroke') && isTransparent(v)) v = 'none'
      if (p === 'stroke-width' || p === 'font-size' || p === 'stroke-dasharray') v = px(v)
      if (p === 'stroke-dasharray' && (v === 'none' || v === '')) return
      if (p === 'font-weight') v = isBoldWeight(v) ? 'bold' : 'normal'
      el.setAttribute(p, v)
    })
    if (el.tagName === 'text' || el.tagName === 'tspan' || el === svg) el.setAttribute('font-family', fontFamily)
    el.removeAttribute('class')
  })
}
